<template>
    <v-btn class="px-2 mx-0" color="error" @click="handleClick">
        {{ $t(label) }}
        <v-icon v-if="icon != '' && icon != null">{{ icon }}</v-icon>
    </v-btn>
</template>

<script>
    export default {
        props: [
            'label',
            'icon'
        ],
        data() {
            return {}
        },
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }
</script>